<template>
	<div>
		<sky-tabs v-model="tabValue" :tabList="tabList" class="tabs-change"> </sky-tabs>
		<!-- 灰度版本 -->
		<grayscale-version v-show="tabValue === 'grayscale'"></grayscale-version>
		<!-- APP -->
		<app-versiono v-show="tabValue === 'APP'"></app-versiono>
		<!-- 客户端 -->
		<client-version v-show="tabValue === 'client'"></client-version>
		<!-- 巡检账号 -->
		<inspectionAccount v-show="tabValue === 'inspectionAccount'"></inspectionAccount>
	</div>
</template>

<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs.vue';
import grayscaleVersion from '@/components/setting/grayscaleVersion.vue';
import appVersiono from '@/components/setting/appVersion.vue';
import clientVersion from '@/components/setting/clientVersion.vue';
import inspectionAccount from '@/components/setting/inspectionAccount.vue';

export default {
	name: 'versionControl',
	data() {
		return {
			tabValue: 'grayscale',
			tabList: [
				{ label: '灰度版本控制', name: 'grayscale' },
				{ label: 'APP版本管理', name: 'APP' },
				{ label: '客户端角色权限', name: 'client' },
				{ label: '巡检账号', name: 'inspectionAccount' },
			],
		};
	},
	methods: {},
	components: { skyTabs, grayscaleVersion, appVersiono, clientVersion, inspectionAccount },
};
</script>

<style lang="scss" scoped>
.tabs-change {
	width: 100%;
	// padding: 10px 10px 15px;
	padding-top: 10px;
	padding-bottom: 15px;
	margin: 20px 0 10px;
	background-color: #fff;
}
</style>
